module.exports = __webpack_public_path__ + "img/l-hd.a4151ed4.jpg";